import { type RcdaNomenclatureVersion, rcdaNomenclatureVersionsWithLabels } from '@orus.eu/product'

import { StringsWithDataEnumDimension } from './strings-with-data-enum-dimension.ts'

export const nomenclatureVersionDimension = new StringsWithDataEnumDimension({
  name: 'nomenclatureVersion',
  displayKeys: { name: 'dimension_name_nomenclature_version' },
  entries: rcdaNomenclatureVersionsWithLabels,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export function isRcdaV3(rcdaNomenclatureVersion: RcdaNomenclatureVersion | null): boolean {
  return !!rcdaNomenclatureVersion && rcdaNomenclatureVersion >= '3.0'
}

export function isRcdaV4(rcdaNomenclatureVersion: RcdaNomenclatureVersion | null): boolean {
  return !!rcdaNomenclatureVersion && rcdaNomenclatureVersion >= '4.0'
}
